import React from 'react';
import { Helmet } from 'react-helmet-async';
import useTranslate from 'components/hooks/useTranslate';
import Container from 'components/ui/Container';
import Spacer from 'components/ui/Spacer';
import RegistrationRenunciationPublicForm from 'components/tree/behavior/candidate/registration/RegistrationRenunciationPublicForm';
import PublicPage from './PublicPage';

function RenunciationPublicPage(): JSX.Element {
  const t = useTranslate();

  return (
    <PublicPage>
      <Helmet>
        <title>
          {t('registration.renunciation.form.title')}
          {' | makersboard'}
        </title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Container>
        <Spacer block="md">
          <RegistrationRenunciationPublicForm />
        </Spacer>
      </Container>
    </PublicPage>
  );
}

export default RenunciationPublicPage;
